module.exports = __webpack_public_path__ + "static/footer-image-ea243ebb9c052abf96a25aee1a47c424.jpg";